import { useParams } from "react-router";
import ParamsChecker from "../../ParamsChecker";
import Footer from "../footer/Footer";
import Navbar from "../navbar/Navbar";
import NewNavbar from "../newNavbar/NewNavbar";
import { ProductDiv } from "./ProductWrapperCSS";
import useSetTags from "../../product/hooks/useSetTags";
import { CONFIG } from "../../product/constants/TitleConfig";

export function ProductWrapper({ children, footerData, navbarData }) {
  const { lang } = useParams();
  useSetTags(CONFIG)

  return (
    <ProductDiv>
      <ParamsChecker />
      {[
        "cz",
        "cs",
        "hu",
        "sk",
        "en",
        "hr",
        "lt",
        "de",
        "it",
        "pl",
        "sl",
        "si",
      ].includes(lang) ? (
        <NewNavbar data={navbarData} />
      ) : (
        <Navbar data={navbarData}></Navbar>
      )}
      {children}
      <Footer data={footerData}></Footer>
    </ProductDiv>
  );
}
